import type { SectorWords } from "@/hooks/use-sector-words";

export interface CsvColumnLabels {
  name: string;
  email: string;
  mobile: string;
  role: string;
  employeeNumber: string;
}

/** Header row in the admin's language and sector; the parser maps every spelling back. */
export function csvHeader(labels: CsvColumnLabels, words: SectorWords): string {
  return [labels.name, labels.email, labels.mobile, words.teamCap, labels.role, labels.employeeNumber].join(";");
}

/** The downloadable template: BOM, semicolons, one example row in the sector's words. */
export function buildCsvTemplate(labels: CsvColumnLabels, words: SectorWords): string {
  return (
    "\uFEFF" +
    csvHeader(labels, words) +
    "\n" +
    ["Förnamn Efternamn", `namn@${words.domain}`, "070-123 45 67", words.deptEx, words.roleEx, "1001"].join(";") +
    "\n"
  );
}

export function csvDataHref(text: string): string {
  return `data:text/csv;charset=utf-8,${encodeURIComponent(text)}`;
}

/** A small sample used by the dev-only "Testa med exempelfil" link. */
export function buildSampleCsv(labels: CsvColumnLabels, words: SectorWords): string {
  const people = [
    ["Anna Andersson", "anna", "070-111 22 33", words.deptEx, words.roleEx, "1001"],
    ["Björn Berg", "bjorn", "070-222 33 44", words.deptEx, words.roleEx, "1002"],
    ["Cecilia Carlsson", "cecilia", "", "Kassa", "Kassamedarbetare", "1003"],
    ["David Dahl", "david", "070-444 55 66", "Kassa", "Kassaansvarig", "1004"],
    ["Eva Ek", "eva", "", "Kolonial", words.roleEx, "1005"],
  ];
  return (
    "\uFEFF" +
    csvHeader(labels, words) +
    "\n" +
    people.map(([name, local, mobile, team, role, nr]) => [name, `${local}@${words.domain}`, mobile, team, role, nr].join(";")).join("\n") +
    "\n"
  );
}
